import find from 'lodash/find';
import head from 'lodash/head';
import { val } from 'angular-ui-router';

export class AboutUsService {
	constructor($resource, ApiService, Upload, DateService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;
		this._upload = Upload;
		this.dateService = DateService;

		this.aboutUsListResourceUrl = this.apiService.getResourceUrl('cms/menus/AboutUs');
		this.aboutUsSequenceResourceUrl = this.apiService.getResourceUrl('cms/menus/AboutUs/sequence');
		this.aboutUsOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/AboutUs');
		this.aboutUsPublishPageResourceUrl = this.apiService.getResourceUrl('cms/menus/AboutUs/publish');

		this.ourStaffMainResourceUrl = this.apiService.getResourceUrl('cms/menus/OurStaff');
		this.ourStaffSequenceResourceUrl = this.apiService.getResourceUrl('cms/staff/sequence');
		this.ourStaffResourceUrl = this.apiService.getResourceUrl('cms/staff/:content_id');
		this.ourStaffContactResourceUrl = this.apiService.getResourceUrl('cms/contact-us');
		this.advisoryCommitteeResourceUrl = this.apiService.getResourceUrl('cms/menus/AdvisoryCommittee');
		this.missionAndHistoryResourceUrl = this.apiService.getResourceUrl('cms/menus/MissionHistory');
		this.missionAndHistoryEditResourceUrl = this.apiService.getResourceUrl('cms/mission-history/:content_id');
		this.partnersAndStakeholdersResourceUrl = this.apiService.getResourceUrl('cms/menus/PartnersStakeholders');
		this.partnersAndStakeholdersEditResourceUrl = this.apiService.getResourceUrl('cms/partners-stakeholders/:content_id');
		this.ruralHealthNetworkResourceUrl = this.apiService.getResourceUrl('cms/menus/RuralHealthNetwork');
		this.ruralHealthNetworkEditResourceUrl = this.apiService.getResourceUrl('cms/rural-health-network/:content_id');
		this.advisoryCommitteeEditResourceUrl = this.apiService.getResourceUrl('cms/advisory-committee/:content_id');
		this.inTheNewsListResourceUrl = this.apiService.getResourceUrl('cms/menus/InTheNews');
		this.inTheNewsAddResourceUrl = this.apiService.getResourceUrl('cms/in-the-news');
		this.inTheNewsGetEditDeleteByIdResourceUrl = this.apiService.getResourceUrl('cms/in-the-news/:content_id');
		this.inTheNewsPublishUnpublishResourceUrl = this.apiService.getResourceUrl('cms/in-the-news/publish');
		// this.inTheNewsFilterResourceUrl = this.apiService.getResourceUrl('cms/menus/InTheNews/filter');

		this.ourStaffOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/OurStaff');
		this.inTheNewsOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/InTheNews');

		this.inTheNewsOverviewResource = this.$resource(this.inTheNewsOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.aboutUsListResource = this.$resource(this.aboutUsListResourceUrl);
		this.ourStaffMainResource = this.$resource(this.ourStaffMainResourceUrl);
		this.missionAndHistoryResource = this.$resource(this.missionAndHistoryResourceUrl);
		this.partnersAndStakeholdersResource = this.$resource(this.partnersAndStakeholdersResourceUrl);
		this.ruralHealthNetworkResource = this.$resource(this.ruralHealthNetworkResourceUrl);
		this.inTheNewsListResource = this.$resource(this.inTheNewsListResourceUrl);
		// this.inTheNewsFilterResource = this.$resource(this.inTheNewsFilterResourceUrl);

		this.advisoryCommitteeEditResource = this.$resource(this.advisoryCommitteeEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.aboutUsSequenceResource = this.$resource(this.aboutUsSequenceResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.aboutUsOverviewResource = this.$resource(this.aboutUsOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.ourStaffOverviewResource = this.$resource(this.ourStaffOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.ourStaffSequenceResource = this.$resource(this.ourStaffSequenceResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.aboutUsPublishPageResource = this.$resource(this.aboutUsPublishPageResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.ourStaffResource = this.$resource(this.ourStaffResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.ourStaffContactResource = this.$resource(this.ourStaffContactResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.advisoryCommitteeResource = this.$resource(this.advisoryCommitteeResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.missionAndHistoryEditResource = this.$resource(this.missionAndHistoryEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.partnersAndStakeholdersEditResource = this.$resource(this.partnersAndStakeholdersEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.ruralHealthNetworkEditResource = this.$resource(this.ruralHealthNetworkEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.inTheNewsAddResource = this.$resource(this.inTheNewsAddResourceUrl, null, {
			save: {
				method: 'POST'
			}
		});

		this.inTheNewsGetEditDeleteByIdResource = this.$resource(this.inTheNewsGetEditDeleteByIdResourceUrl, null, {
			get: {
				method: 'GET',
				params: {
					content_id: '@content_id'
				}
			},
			update: {
				method: 'PUT',
				params: {
					content_id: '@content_id'
				}
			},
			delete: {
				method: 'DELETE',
				params: {
					content_id: '@content_id'
				}
			}
		});

		this.inTheNewsPublishUnpublishResource = this.$resource(this.inTheNewsPublishUnpublishResourceUrl, null, {
			update: {
				method: 'POST'
			}
		});
	}

	/**
	 * function for get overview
	 * @return {object} 
	 */
	_getOverviewDetails(details) {
		return {
			id: details.content_id,
			displayName: details.display_name,
			title: details.title,
			description: details.description,
			overview: details.overview,
			image: details.image,
			name: details.name
		}
	}

	/**
	 * function for set overview
	 * @return {object} 
	 */
	_setOverviewObject(details) {
		return {
			title: details.title,
			description: details.description,
			overview: details.overview,
			image: details.image
		}
	}

	/**
	 * function for get list
	 * @return {array} 
	 */
	_getContentDetailsMain(content) {
		return content.map(({ title, description, name }) => ({ title, description, name }));
	}


	/**
	 * function for get sequence list
	 * @return {array} 
	 */
	_getContentSequence(value) {
		return value.map((content) => {
			return {
				id: content.menu_id || content.content_id,
				sortOrder: content.sort_order,
				title: content.title || content.name
			}
		});
	}

	/**
	 * function for set sequence staff
	 * @return {array} 
	 */
	_setContentSequenceStaff(value) {
		return value.map((content) => {
			return {
				content_id: content.id,
				sort_order: content.sortOrder
			}
		});
	}

	_getContentSequenceStaff(value) {
		return value.map((content) => {
			return {
				id: content.content_id,
				sortOrder: content.sort_order,
				title: content.name
			}
		});
	}

	/**
	 * function for set sequence list
	 * @return {array} 
	 */
	_setContentSequence(value) {
		return value.map((content) => {
			return {
				menu_id: content.id,
				sort_order: content.sortOrder,
				// title: content.title
			}
		});
	}

	//get publish status object for display
	_getPublishPageListObject(values) {
		return values.map(value => ({
			id: value.menu_id,
			isActive: value.is_active,
			title: value.title
		}));
	}

	//set publish status object for update
	_setPublishPageListObject(values) {
		return values.map(value => ({
			menu_id: value.id,
			is_active: value.isActive
		}));
	}

	_getStaffDetails(list) {
		return list.values.map((value) => {
			return {
				lastName: value.last_name,
				firstName: value.first_name,
				designation: value.designation,
				id: value.content_id,
				image: value.image || "",
				slug: value.slug || ""
			}
		});
	}

	_setStaffDetails(value) {
		return {
			first_name: value.firstName,
			last_name: value.lastName,
			designation: value.designation,
			image: value.image
		}
	}

	_getContentDetails(value) {
		return {
			id: value.content_id,
			description: value.description,
			images: this._getContentImagesObject(value.images) || [],
			videos: value.videos || []
		}
	}

	_getContentImagesObject(values) {
		return values ? values.map(({ uuid }) => ({ uuid, status: -1 })) : [];
	}

	_setContentDetails(value) {
		return {
			description: value.description,
			images: value.images || [],
			videos: value.videos || []
		}
	}

	_getNewsObject(value) {
		return {
			id: value.content_id,
			title: value.title,
			description: value.description,
			images: this._getContentImagesObject(value.images) || [],
			videos: value.videos || [],
			publishAt: value.publish_at,
			firstName: value.first_name,
			lastName: value.last_name,
			newsDate: this.dateService.parseDateFromServerDate(value.news_date),
			slug: value.slug || ''
		}
	}

	_setNewsObject(value) {
		return {
			title: value.title,
			description: value.description,
			images: value.images || [],
			videos: value.videos || [],
			news_date: this.dateService.parseDateToServerDate(value.newsDate, new Date().getHours(), new Date().getMinutes(), new Date().getSeconds()),
			is_active: value.isActive
		}
	}

	_getInTheNewsDetails(list) {
		return list.values.map(value => this._getNewsObject(value));
	}

	_getYearDetails(list) {
		return list.values.map(value => ({
			id: value,
			name: value
		}));
	}

	_getStaffDetailsObject({ content_id, first_name, last_name, designation, image = "" }) {
		return {
			id: content_id,
			firstName: first_name,
			lastName: last_name,
			designation: designation,
			image: image
		};
	}

	getOurStaffDetails(details) {
		return {
			overview: this._getOverviewDetails(details.data.menuOverviewDetails),
			ourStaffList: this._getStaffDetails(find(details.data.content, ['name', 'OurStaff']))
		};
	}

	/**
	 * function to get our staff overview
	 * @return {object} [information related to our staff overview]
	 */
	getOurStaffOverview() {
		const promise = this.ourStaffOverviewResource.get().$promise;

		return promise.then(details => this._getOverviewDetails(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});

	}

	/**
	 * function to edit our staff overview
	 * @return {object} [information related to our staff overview]
	 */
	setOurStaffOverview(details) {
		const promise = this.ourStaffOverviewResource.update(this._setOverviewObject(details)).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getOurStaffSequence({ data: { content: { values } } }) {
		return this._getContentSequence(values)
	}


	/**
	 * function to edit about us sequence
	 * @return {object} [information related to about us sequence for edit]
	 */
	setOurStaffSequence(sequenceObj) {
		const promise = this.ourStaffSequenceResource.update(this._setContentSequenceStaff(sequenceObj)).$promise;

		return promise.then((response) => response);
	}

	getInTheNewsDetails(details) {
		return {
			overview: this._getOverviewDetails(details.data.menuOverviewDetails),
			list: this._getInTheNewsDetails(find(details.data.content, ['name', 'InTheNews'])),
			year: this._getYearDetails(find(details.data.content, ['name', 'year'])),
			count: details.data.count
		};
	}

	getInTheNewsOverview() {
		const promise = this.inTheNewsOverviewResource.get().$promise;

		return promise.then(details => this._getOverviewDetails(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});

	}

	updateInTheNewsOverview(details) {
		const promise = this.inTheNewsOverviewResource.update(this._setOverviewObject(details)).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getNewsDetailsById(details) {
		return this._getNewsObject(details.data);
	}

	getInTheNewsFilterData({ year, filterDetails: { limit, pageId, isPublished } }, url) {
		this.inTheNewsFilterResourceUrl = this.apiService.getResourceUrl(`cms/menus/${url}`);
		this.inTheNewsFilterResource = this.$resource(this.inTheNewsFilterResourceUrl);

		const promise = this.inTheNewsFilterResource.get({
			year,
			limit,
			page_id: pageId,
			is_published: isPublished
		}).$promise;

		return promise
			.then(({ data }) => ({
				list: this._getInTheNewsDetails(find(data.content, ['name', 'InTheNews'])),
				count: find(data.content, ['name', 'InTheNews']).count
			}))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/**
	 * function to delete news
	 * @return {object} [information related to news for delete]
	 */
	deleteNews(id) {
		const promise = this.inTheNewsGetEditDeleteByIdResource.delete({ content_id: id }).$promise;

		return promise.then(details => details.data)
			.catch((err) => {
				throw this.apiService.getErrorMessage(err);
			});
	}

	/**
	 * function to publish/unpublish news
	 * @return {object} [information related to news for publish/unpublish]
	 */
	publishUnpublishNews(id) {
		const promise = this.inTheNewsPublishUnpublishResource.update({
			content_id: id
		}).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}
}


// WEBPACK FOOTER //
// ./src/app/components/about-us/about-us.service.js